import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const AddToCartMobileCheckIcon = ({ width = '9', height = '6', fill = '#333333', }) => (React__default.createElement(SvgImg, { viewbox: "0 0 9 6", title: "app", width: width, height: height, fill: fill },
    React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 0.8535L7.6465 0.5L3.25 4.89625L1.3535 3L1 3.3535L3.25 5.6035L8 0.8535Z", fill: "white", stroke: "white", strokeWidth: "0.5" })));

export { AddToCartMobileCheckIcon };
